import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'megaByte'
})
export class MegaBytePipe implements PipeTransform {

  transform(value: number) {

    return (Math.round(100 * value / (1024 * 1024)) / 100).toString();
  }

}
